import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';
import { MagazineTeaserStoryblok } from 'storyblok-types';
import { IconSVG } from 'atoms/IconSVG';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { renderLink } from 'atoms/StoryBlokLink';
import { Body, Title } from 'atoms/Typography/Typography';
import { IServerProps } from 'pages/StoryBlok/types';
import styles from './styles.module.css';

export const MagazineTeaser: FC<{
  blok: MagazineTeaserStoryblok;
  serverProps: IServerProps;
}> = ({ blok }) => {
  const url = renderLink(blok?.link);

  return (
    <div className={styles.teaser} {...storyblokEditable(blok)}>
      <Link href={url} className={styles.link}>
        <div
          className={styles.backgroundImage}
          style={{ backgroundImage: `url(${blok?.image?.filename}` }}
        ></div>
        <Image
          src={blok?.image?.filename}
          alt={blok?.image?.alt}
          className={styles.img}
        />
        <div
          className={styles.content}
          style={{ backgroundColor: blok?.background?.color }}
        >
          <Title type="lg">{blok.headline}</Title>

          <div className={styles.textBlockFooter}>
            <Body type="sm">{blok.date}</Body>
            <IconSVG type="arrowLongRight" />
          </div>
        </div>
      </Link>
    </div>
  );
};
